import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7669abfa")

_pushScopeId("data-v-7669abfa")
const _hoisted_1 = { class: "content" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "info" }, [
  /*#__PURE__*/_createVNode("b", null, [
    /*#__PURE__*/_createVNode("p", { class: "text-3xl" }, " Fábio Durães ")
  ]),
  /*#__PURE__*/_createVNode("p", null, " Consultor de Investimentos "),
  /*#__PURE__*/_createVNode("p", null, " +351 916 414 169 ")
], -1)
const _hoisted_3 = { class: "logos" }
const _hoisted_4 = { href: "https://www.fb.me/vilasporto" }
const _hoisted_5 = { href: "https://www.instagram.com/vilasporto" }
const _hoisted_6 = /*#__PURE__*/_createVNode("a", { href: "https://www.idealista.pt/pro/vilasporto" }, [
  /*#__PURE__*/_createVNode("b", null, [
    /*#__PURE__*/_createVNode("p", { class: "text-4xl whitespace-nowrap" }, " VER IMÓVEIS ")
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "separator" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("main", null, [
  /*#__PURE__*/_createVNode("form", {
    action: "mailto:adae@outlook.pt",
    method: "post",
    enctype: "multipart/form-data"
  }, [
    /*#__PURE__*/_createVNode("div", { class: "flex justify-center text-3xl" }, [
      /*#__PURE__*/_createVNode("span", { class: "text-orange whitespace-nowrap" }, [
        /*#__PURE__*/_createVNode("b", null, " Fale connosco ")
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "form" }, [
      /*#__PURE__*/_createVNode("div", { class: "field" }, [
        /*#__PURE__*/_createVNode("span", null, " Nome "),
        /*#__PURE__*/_createVNode("input", {
          type: "text",
          name: "name"
        })
      ]),
      /*#__PURE__*/_createVNode("div", { class: "field" }, [
        /*#__PURE__*/_createVNode("span", null, " E-mail "),
        /*#__PURE__*/_createVNode("input", {
          type: "text",
          name: "mail"
        })
      ]),
      /*#__PURE__*/_createVNode("div", { class: "field flex-grow" }, [
        /*#__PURE__*/_createVNode("span", null, " Mensagem "),
        /*#__PURE__*/_createVNode("textarea", {
          name: "comment",
          class: "h-full"
        })
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "btns" }, [
      /*#__PURE__*/_createVNode("input", {
        type: "reset",
        value: "Apagar"
      }),
      /*#__PURE__*/_createVNode("input", {
        type: "submit",
        value: "Enviar"
      })
    ])
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Svg = _resolveComponent("Svg")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("nav", null, [
      _createVNode(_component_Svg, {
        class: "h-1/2",
        source: "logo"
      }),
      _hoisted_2,
      _createVNode("div", _hoisted_3, [
        _createVNode("a", _hoisted_4, [
          _createVNode(_component_Svg, {
            class: "h-8",
            source: "facebook"
          })
        ]),
        _createVNode("a", _hoisted_5, [
          _createVNode(_component_Svg, {
            class: "h-8",
            source: "instagram"
          })
        ])
      ]),
      _hoisted_6
    ]),
    _hoisted_7,
    _hoisted_8
  ]))
})